export default {
    development: {
        compositionApi: 'https://api.test-sdbleerplatform.nl/api/1.0/composition',
        ltiConsumerApi: 'https://lticonsumer.test-sdbleerplatform.nl',
        learningApi: 'https://api.test-sdbleerplatform.nl',
        sdbIdentityUrl: 'test-sdbidentity.nl',
    },
    production: {
        compositionApi: 'https://api.sdbleerplatform.nl/api/1.0/composition',
        ltiConsumerApi: 'https://lticonsumer.sdbleerplatform.nl',
        learningApi: 'https://api.sdbleerplatform.nl',
        sdbIdentityUrl: 'sdbidentity.nl',
    },
}
